import { toast } from 'sonner';
import { captureException } from '@sentry/react';
import { getDownloadURL, ref } from 'firebase/storage';

import { storage } from '../../../firebase-config.js';
import type { DocumentFromStorage } from '../DocumentManager.types.ts';

const downloadFile = async (item: DocumentFromStorage) => {
  if (!item) {
    throw new Error('Document item is required');
  }

  // TODO: @krochet94 is this deprecated?
  if (item?.url) {
    return item.url;
  }

  const id = item.id || item.fileName;

  if (!id) {
    throw new Error('Document id is required');
  }

  const filePath = item.fullPath;

  return await getDownloadURL(ref(storage, filePath));
};

export const downloadFileWithToast = async (item: DocumentFromStorage) => {
  try {
    await toast
      .promise(downloadFile(item), {
        loading: 'Downloading document...',
        success: (url) => {
          window.open(url, '_blank', 'noopener,noreferrer');

          return {
            message: 'Document downloaded successfully',
            action: {
              label: 'View',
              onClick: () => {
                window.open(url, '_blank', 'noopener,noreferrer');
              },
            },
          };
        },
      })
      .unwrap();
  } catch (error) {
    captureException(error, {
      tags: {
        issueIn: 'downloadFileWithToast',
      },
      extra: { item },
    });

    toast.error('Failed to download document');
  }
};
